// extracted by mini-css-extract-plugin
export default {"swiperWrapper":"slider_swiperWrapper__j7y5J","sliderPosition":"slider_sliderPosition__cxKLA","sliderHeader":"slider_sliderHeader__lP4za"};